export const HEJA_STATS = {
  teamCount: '500,000+',
  appStoreRating: '4.8/5',
  appStoreRatingCount: '35K+',
  fundraisingDancerCount: '30+',
} as const
